<template>
  <div class="weui-msg__custom-area">
    <p v-if="partnerList.length == 0">请先申请成为商户管理员</p>
    <p v-else class="weui-msg__desc merchant" @click="switchList">
      <span v-if="merchant == null">请选择您要管理的商户</span>
      <span v-else>当前商户：【{{ merchant }}】</span>
    </p>
    <div class="merchant-list" v-show="display">
      <div class="weui-cells__group weui-cells__group_form ">
        <div class="weui-cells" style="margin: 10px">
          <a
            class="weui-cell weui-cell_access"
            @click="toPartner(partner.partnerID,partner.desc)"
            v-for="(partner, index) in partnerList"
            :key="index"
          >
            <span class="weui-cell__bd"> {{ partner.desc }}</span>
            <span class="weui-cell__ft"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {v4 as uuidv4} from "uuid";
import wx from "jweixin-1.6.0";
import {getPosListByPartnerId} from "../graphql/api";
import JQ from "jquery";

export default {

  data() {
    return {
      partnerList: [],
      display: false,
      merchant: null
    }
  },
  mounted() {
    this.checklogin();
  },
  methods: {
    switchList() {
      this.display = !this.display;
    },

    showError() {
      var $warnToast = JQ("#warnToast");
      $warnToast.fadeIn(100);
      setTimeout(function () {
        $warnToast.fadeOut(100);
      }, 5000);
    },
    getPosList(partnetid) {
      console.log("调用getPosList");
      let that = this;
      let params = {
        partnerId: partnetid,
        page: 1,
        size: 10
      }
      getPosListByPartnerId(params).then(res => {
        console.log('根据partnerId查找到的网点数据是', res);
        if ((res.data == null) || res.data.length == 0) {
          that.errMessage += ":网点信息为空";
          that.showError();
          return;
        }

        sessionStorage.setItem("posListOf_" + partnetid, JSON.stringify(res.data.findPosByPartnerId));

        sessionStorage.setItem("partnerid", partnetid);

        sessionStorage.setItem("PID_INITED", "true");

        console.log('当前url', that.$route);
        if(that.$route.query.fromPath){
          console.log('存在页面连接');
          that.$router.push({
            path: that.$route.query.fromPath,
          })
        }else{
          that.redraw();
          that.ing = false;
        }
      })
    },

    redraw() {
      console.log("redraw", this.$route.path);

      let tar = this.$route.path;

      if (tar == "/") tar = "/report_flow";
      this.$router.push({
        "path": tar,
        "query": {"tm": (new Date()).getTime()}
      })
    },

    toPartner(pid, desc) {
      console.log(pid);
      this.merchant = desc;
      this.display = false;
      this.jsapiInit(pid);
    },

    jsapiInit(pid) {
      console.log('开始获取jsAPI权限');
      let that = this;
      that.ing = true;
      let jsApiList = [
        "scanQRCode",
        "chooseWXPay",
        "getLocation",
        "openLocation",
        "scanQRCode",
        "updateTimelineShareData",
        "updateAppMessageShareData",
        "startRecord",
        "stopRecord",
        "onVoiceRecordEnd",
        "uploadVoice",
        "downloadVoice",
        "playVoice",
        "scanQRCode"
      ];
      // 发起请求获取Jsapi配置凭证
      let url = window.location.href.split("#")[0];

      axios
        .post("/customer/zmxcl/entry", {
          msgType: "getJsapiConfig", //
          ver: "1", //
          msgID: uuidv4(), //
          timestamp: Date.now(), //
          url: url, //
          // 拦截响应
        })
        .then((response) => {
          let data = response.data.wxJsapiConfigRequestInfo;

          // 通过config接口注入权限验证配置
          wx.config({
            debug: false, //开启调试模式，调用所有api的返回值会在客户端alert出来，
            appId: data.appId, //公众号唯一标识
            timestamp: data.timestamp, //生成签名的时间戳
            nonceStr: data.nonceStr, //生成签名的随机串
            signature: data.signature, //签名
            jsApiList: jsApiList, //需要使用的JS接口列表
          });

          wx.error(() => {
            console.log("wx.error : begin");
            that.ingText = "微信初始化错误，再试下";
            return;
          });

          // 尝试通过微信获取地理位置，如果没有获取到，在用户未重新开发或刷新页面前，不会再次去获取
          wx.ready(() => {
            console.log("wx.ready : begin");
            //
            if (sessionStorage.getItem("location_flag") != "1")
              wx.getLocation({
                type: "gcj02", //jssdk获取的坐标类型
                success: function (res) {
                  console.log("wx.getLocation : ok 1");
                  if (res.errMsg === "getLocation:ok") {
                    sessionStorage.setItem("location_flag", "1");
                    sessionStorage.setItem("mylng", res.longitude);
                    sessionStorage.setItem("mylat", res.latitude);
                  }
                  that.ingText = "配置完成";
                  console.log("wx.getLocation : ok 2");
                },
                fail: function (res) {
                  console.log("wx.getLocation : fail 1")
                  that.ingText = "定位失败";
                },
                cancel: function () {
                  console.log("wx.getLocation : cancel 1");
                  that.ingText = "取消定位";
                },
                complete: function () {
                  console.log("wx.getLocation : complete 1");

                },
              });
            console.log("wx.ready : end");
            that.getPosList(pid);
          });
        });
    },
    checklogin() {
      // 从checklogin中获得openid，而非URL
      let that = this;
      axios.get("/customer/checkLogin").then((res) => {
        console.log(res.data);
        if (res.data.retcode === "0") {
          sessionStorage.setItem("login", true);
          sessionStorage.setItem("openid", res.data.userID);
          that.checkRight(res.data.userID);
        } else {
          window.location.href =
            "https://omc.nationaiot.com/customer/pageEntry?state=4";
        }
      });
    },
    checkRight(openid) {
      let that = this;
      that.ing = true;

      axios
        .get(
          "/zmomc/checkRight?openid=" + openid + "&tm=" + new Date().getTime()
        )
        .then((res) => {
          console.log(res.data);
          if (res.data == null || res.data.length == 0) {
            that.showError();
            return;
          }
          that.partnerList = res.data;
          that.ing = false;

          if (that.partnerList.length == 1) {
            setTimeout(() => {
              let partner = that.partnerList[0];
              that.toPartner(partner.partnerID, partner.desc);
            }, 200);
          }


        });
    },
  }

}
</script>

<style>
.merchant {
  color: blue !important;
}

.merchant-list {
  border: 1 dashed px;
  border-radius: 10% !important;
  height: 100vh;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/merchant.vue